export default __webpack_public_path__ + "ffdc8c24bec11b4c6b51548ddc8bdf66.svg";